import { apiService } from '.';
import { Tender, TenderFilter } from '../shared/types/tender';
import { TenderCalendar } from '../shared/types/tender-calendar';

export const asyncGetTenders = async (
    filters?: TenderFilter,
    page?: number,
    pageSize?: number
): Promise<{ items: Tender[]; length: number }> => {
    try {
        const {
            items: data,
        }: {
            items: { items: Tender[]; length: number };
        } = await apiService.get('/api/tender', {
            limit: pageSize || 20,
            page: page || 0,
            ...filters,
        });

        return data || { items: [], length: 0 };
    } catch (error) {
        return { items: [], length: 0 };
    }
};

export const asyncGetTender = async (
    idTender: string
): Promise<Tender | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: Tender;
        } = await apiService.get(`/api/tender/${idTender}`);

        return data;
    } catch (error) {}
};

export const asyncCreateTender = async (info: Tender) => {
    try {
        const {
            items: data,
        }: {
            items: Tender;
        } = await apiService.post('/api/tender', info);
        return data;
    } catch (error) {}
};

export const asyncUpdateTender = async (id: string, tender: Tender) => {
    try {
        const res: any = await apiService.patch(`/api/tender/${id}`, tender);
        return res;
    } catch (error) {}
};

export const asyncDeleteTender = async (id: string | number) => {
    return await apiService.delete(`/api/tender/${id}`);
};

export const asyncAssignUsers = async (
    tenderId: string,
    userIds: string[]
): Promise<void> => {
    try {
        await apiService.patch(`/api/tender/${tenderId}/users`, {
            userIds,
        });
    } catch (error) {
        throw error;
    }
};

export const asyncModifyCalendar = async (
    tenderId: string,
    calendar: TenderCalendar
): Promise<void> => {
    try {
        await apiService.patch(`/api/tender/${tenderId}/calendar`, calendar);
    } catch (error) {
        throw error;
    }
};
